import getExperienceItems from 'checkout/selectors/view/items/getExperienceItems'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'
import { isStandaloneExperience } from 'selectors/isStandaloneExperience'
import { createSelector } from 'reselect'

/**
 * Leaf selector for gift-offer experience checkout mode.
 * Kept out of experience.ts so luxPlusSubscription can use it without importing
 * the broader experience view barrel.
 */
export const checkIsExperienceGiftOfferOrderMode = createSelector(
  (state: App.State) => getIsEnabledLuxPlusDiscountedExperiences(state),
  (state: App.State) => isStandaloneExperience(state),
  (state: App.State) => getExperienceItems(state),
  (isLuxPlusEnabled, isStandaloneExperience, experienceItems) => {
    const experienceItem = experienceItems[0]
    if (!isLuxPlusEnabled || !isStandaloneExperience || !experienceItem?.isGift) return false
    return experienceItem?.orderMode === 'gift-offer'
  },
)
